import {defineStore} from 'pinia'
import {ref} from "vue";
import {request} from "@/ts/request";
import {RequestStatus} from "@/ts/interfaces/requests/statusEnum";
import {userUpdatePasswordPathName} from "@/ts/apiRoutes";

export const useUserPasswordUpdateStore = defineStore('user-password-update',  () => {
    const status = ref<RequestStatus | null >(RequestStatus.INITIAL)

    const errors = ref<object | null>(null)

    async function edit(data: object) {
        status.value = RequestStatus.LOADING

        const response = await request(userUpdatePasswordPathName, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Content-type': 'application/json; charset=UTF-8'
            },
        })

        status.value = response.ok ? RequestStatus.SUCCESS : RequestStatus.ERROR

        if(!response.ok) {
            errors.value = await response.json()
        }

        return response;
    }

    return { status, edit, errors }
})